module.exports = __webpack_public_path__ + "img/symbol_6.cd09d391.png";